import HistoricalBreakevenDetailsInquiry from './historical-breakeven-details-inquiry.vue'
export default HistoricalBreakevenDetailsInquiry
